import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import TRANSLATIONS_ZH from 'locales/zh-tw';
import TRANSLATIONS_EN from 'locales/en';

const resources = {
  en: {
    translation: TRANSLATIONS_EN,
  },
  zh: {
    translation: TRANSLATIONS_ZH,
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'zh',
    fallbackLng: 'zh', // use en if detected lng is not available
    saveMissing: true, // send not translated keys to endpoint
    // keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
